import { useState } from 'react';
import { Control } from 'react-hook-form';
import { Grid, Paper, TabPanel, Tooltip, useTheme, useAppSelector, RootState } from '../../../base';
import { StyledTabs, StyledTab } from './UserSettingsTabs.styles';
import { useTranslation } from 'react-i18next';
import EmailSettingsTab from '../../SettingsComponents/EmailSettingsTab';
import SocialMediaTab from '../../SettingsComponents/SocialMediaTab';
import NotificationsTab from '../../SettingsComponents/NotificationsTab';
import UserInformationTab from '../UserInformationTab';
import { a11yProps, EmailSettingsContext, FeatureFlags } from '../../../common';
import { organizationSelectors } from '../../../actions';

interface Props {
    control: Control<any>;
}

const UserSettingsTabs = ({ control }: Props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const [value, setValue] = useState(0);
    const isEmailSettingsOn = useAppSelector((state: RootState) =>
        organizationSelectors.isFlagOn(state, FeatureFlags.EMAIL_SETTINGS)
    );

    const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const tabsList = [
        {
            label: t('userSettings.tabs.userInformation'),
            component: <UserInformationTab control={control} />,
            disabled: false,
        },
        {
            label: t('userSettings.tabs.socialMedia'),
            component: <SocialMediaTab />,
            disabled: true,
        },
        {
            label: t('userSettings.tabs.notifications'),
            component: <NotificationsTab control={control} />,
            disabled: true,
        },
        {
            label: t('userSettings.tabs.emailSettings'),
            component: <EmailSettingsTab context={EmailSettingsContext.USER} />,
            disabled: !isEmailSettingsOn,
        },
    ];

    return (
        <Paper>
            <Grid container>
                <Grid item xs={12} md={3}>
                    <StyledTabs
                        orientation="vertical"
                        variant="scrollable"
                        value={value}
                        onChange={handleChange}
                        aria-label="User settings tabs"
                    >
                        {tabsList.map((tab, index) =>
                            tab.disabled ? (
                                <Tooltip
                                    key={index}
                                    title={t('userSettings.comingSoon')}
                                    placement="right"
                                >
                                    <span>
                                        <StyledTab
                                            label={tab.label}
                                            disabled
                                            {...a11yProps(index)}
                                        />
                                    </span>
                                </Tooltip>
                            ) : (
                                <StyledTab
                                    key={index}
                                    label={tab.label}
                                    {...a11yProps(index)}
                                />
                            )
                        )}
                    </StyledTabs>
                </Grid>
                <Grid item xs={12} md={9}>
                    {tabsList.map((tab, index) => (
                        <TabPanel
                            key={index}
                            value={value}
                            index={index}
                            style={{ width: '100%' }}
                            boxStyle={{ padding: theme.spacing(3) }}
                        >
                            {tab.component}
                        </TabPanel>
                    ))}
                </Grid>
            </Grid>
        </Paper>
    );
};

export default UserSettingsTabs;
